module.exports = __webpack_public_path__ + "img/pro_five_5.a8f6aeba.jpg";